/**
 * @description Number formatting
 *
 */

export const numberFormatter = new Intl.NumberFormat('nl-NL', { style: 'decimal' })
